<template>
  <div :class="{ ['is-invalid']: errors && errors.length > 0 }">
    <b-input type="time" v-model="from" :state="state"/>
    <span class="sep">To</span>
    <b-input type="time" v-model="to" :state="state"/>
  </div>
</template>

<script>
import baseInput from './_base'
import SelectInput from './select-input'

export default {
  mixins: [baseInput],

  data() {
    return {
      from: this.value[0],
      to: this.value[1],
    }
  },

  watch: {
    from(newTime) {
      this.$emit('input', [newTime, this.value[1]])
    },

    to(newTime) {
      this.$emit('input', [this.value[0], newTime])
    },

    value(newVal) {
      this.from = this.value[0]
      this.to = this.value[1]
    },
  },

  components: {
    SelectInput,
  },
}
</script>

<style lang="scss">
.live-input--time-range {
  input.form-control {
    display: inline-block;
    width: auto;
    margin-top: 1rem;
    padding-right: 0;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    height: auto;
  }

  .sep {
    padding: 0 1.5rem;
    position: relative;
    letter-spacing: 0.83px;
    font-size: $font-size-xxs;
    text-transform: uppercase;
    color: $input-placeholder-color;
  }
}
</style>